<script setup>
// Google Ads > Kampanyalar
//
// Durdur/baslat eylemi AYRI bir ekranda degil burada: kullanici
// harcamayi gorup ayni satirda mudahale edebilmeli.
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { useAlert } from 'dashboard/composables';
import GoogleAdsKabuk from './GoogleAdsKabuk.vue';
import GoogleAdsTablo from './GoogleAdsTablo.vue';
import { getir, gonder, hataMetni } from './kopru.js';

const { t } = useI18n();
const route = useRoute();

const satirlar = ref([]);
const paraBirimi = ref('');
const yukleniyor = ref(false);
const hata = ref('');

const SUTUNLAR = [
  { alan: 'ad', anahtar: 'GOOGLE_ADS.SUTUN.AD', siralanabilir: true, vurgu: true },
  { alan: 'durum', anahtar: 'GOOGLE_ADS.SUTUN.DURUM', tur: 'durum', siralanabilir: true },
  { alan: 'kanal', anahtar: 'GOOGLE_ADS.SUTUN.KANAL', tur: 'etiket', siralanabilir: true },
  { alan: 'gunluk_butce', anahtar: 'GOOGLE_ADS.SUTUN.BUTCE', tur: 'para', siralanabilir: true },
  { alan: 'harcama', anahtar: 'GOOGLE_ADS.SUTUN.HARCAMA', tur: 'para', siralanabilir: true },
  { alan: 'gosterim', anahtar: 'GOOGLE_ADS.SUTUN.GOSTERIM', tur: 'sayi', siralanabilir: true },
  { alan: 'tiklama', anahtar: 'GOOGLE_ADS.SUTUN.TIKLAMA', tur: 'sayi', siralanabilir: true },
  { alan: 'donusum', anahtar: 'GOOGLE_ADS.SUTUN.DONUSUM', tur: 'sayi', siralanabilir: true },
  { alan: 'tiklama_orani', anahtar: 'GOOGLE_ADS.SUTUN.TIKLAMA_ORANI', tur: 'yuzde', siralanabilir: true },
];

// Son secilen araligi tutuyoruz: durum degistirdikten sonra listeyi ayni
// donemle tazelemek gerekiyor.
const sonAralik = ref('30');
const islemdeki = ref(null);

// Duraklat / baslat.
//
// Yazma yuzeyi BILEREK dar: butce ve hedefleme buradan degistirilmiyor.
// Para harcayan, geri alinmasi zor islemler ayri bir onay akisi olmadan
// acilmamali. Duraklatma ise tersine cevrilebilir ve acil durumda en cok
// ihtiyac duyulan islem.
const durumDegistir = async satir => {
  const yeni = satir.durum === 'ENABLED' ? 'PAUSED' : 'ENABLED';
  islemdeki.value = satir.id;
  try {
    await gonder(route.params.accountId, `kampanyalar/${satir.id}/durum`, {
      durum: yeni,
    });
    useAlert(
      yeni === 'PAUSED'
        ? t('GOOGLE_ADS.DURAKLATILDI')
        : t('GOOGLE_ADS.BASLATILDI')
    );
    await yukle(sonAralik.value);
  } catch (e) {
    useAlert(hataMetni(e, t('GOOGLE_ADS.HATA')));
  } finally {
    islemdeki.value = null;
  }
};

const yukle = async aralik => {
  sonAralik.value = aralik || sonAralik.value;
  yukleniyor.value = true;
  hata.value = '';
  try {
    const veri = await getir(route.params.accountId, 'kampanyalar', { aralik });
    satirlar.value = veri.kampanyalar || [];
    paraBirimi.value = veri.para_birimi || '';
  } catch (e) {
    satirlar.value = [];
    hata.value = hataMetni(e, t('GOOGLE_ADS.HATA'));
  } finally {
    yukleniyor.value = false;
  }
};
</script>

<template>
  <GoogleAdsKabuk
    :baslik="t('GOOGLE_ADS.KAMPANYALAR')"
    :aralik-goster="true"
    @aralik="yukle"
  >
    <div class="flex flex-col gap-3">
      <p v-if="hata" class="text-sm text-n-ruby-11">{{ hata }}</p>
      <div v-if="yukleniyor" class="flex justify-center p-10">
        <Spinner class="text-n-brand" />
      </div>
      <GoogleAdsTablo
        v-else
        :sutunlar="SUTUNLAR"
        :satirlar="satirlar"
        :para-birimi="paraBirimi"
        varsayilan-siralama="harcama"
      >
        <template #eylem="{ satir }">
          <Button
            size="xs"
            variant="faded"
            :icon="satir.durum === 'ENABLED' ? 'i-lucide-pause' : 'i-lucide-play'"
            :label="
              satir.durum === 'ENABLED'
                ? t('GOOGLE_ADS.DURAKLAT')
                : t('GOOGLE_ADS.BASLAT')
            "
            :is-loading="islemdeki === satir.id"
            :disabled="islemdeki === satir.id || satir.durum === 'REMOVED'"
            @click="durumDegistir(satir)"
          />
        </template>
      </GoogleAdsTablo>
    </div>
  </GoogleAdsKabuk>
</template>
